import { useMemo, useState } from 'react';

import { makeStyles } from '@material-ui/core/styles';

import { DeliveryPointDetails } from '../../types/delivery-point-details.type';
import { useFindOrders } from '../../../orders/hooks/get-orders.hook';
import { OrderTableWithDetails } from '../../../orders/components/Tables/OrderTableWithDetails.component';
import { mapOrderToTableRow } from '../../../orders/utils/map-order-to-table-row.util';
import { ORDER_TABLE_HEADERS } from '../../../orders/constants/order-table-headers.constant';
import { ORDER_TABLE_ROWS_PER_PAGE_OPTIONS } from '../../../orders/constants/order-table-pagination.constants';

const useStyles = makeStyles({
  root: {
    display: 'flex',
    flexDirection: 'column',
    gap: '0.5rem',
  },
});

type Props = {
  deliveryPoint: DeliveryPointDetails;
};

export default function DeliveryPointOrdersTab({ deliveryPoint }: Props) {
  const classes = useStyles();

  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(ORDER_TABLE_ROWS_PER_PAGE_OPTIONS[0]);

  const { loading, orders, totalCount } = useFindOrders({
    page: page + 1,
    limit: rowsPerPage,
    sortDirection: 'desc',
    filters: { deliveryId: deliveryPoint.id },
  });

  const tableRows = useMemo(() => orders.map(mapOrderToTableRow), [orders]);

  const handleRowsPerPageChange = (newRowsPerPage: number) => {
    setRowsPerPage(newRowsPerPage);
    setPage(0);
  };

  return (
    <section className={classes.root}>
      <OrderTableWithDetails
        maxHeight="60svh"
        isLoading={loading}
        headers={ORDER_TABLE_HEADERS}
        orders={tableRows}
        totalCount={totalCount}
        page={page}
        rowsPerPage={rowsPerPage}
        rowsPerPageOptions={ORDER_TABLE_ROWS_PER_PAGE_OPTIONS}
        onPageChange={setPage}
        onRowsPerPageChange={handleRowsPerPageChange}
      />
    </section>
  );
}
